import React, { useState } from "react";
import "../../Styles/ContactUs.css";

function ContactUs() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [status, setStatus] = useState(null);
  const [communication, setCommunication] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !email || !message || !agreeTerms) {
        setStatus("Please fill all fields and agree to the terms.");
        return;
    }

    let newMessage = `
      Name: ${firstName} ${lastName}
      ${message}

      Accepted SMS communication: ${communication}
    `

    try {
        const res = await fetch("https://fqzh94i59u.us-east-2.awsapprunner.com/notifications/send-email", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            to: "info@bigcircleauctions.com",
            subject: `New Contact Form Submission from ${email}`,
            text: newMessage,
            }),
        });

        const data = await res.json();
        if (data.success) {
            setStatus("✅ Your message has been sent successfully!");
            setEmail("");
            setMessage("");
            setAgreeTerms(false);
        } else {
            setStatus("❌ Failed to send message. Please try again.");
        }
    } catch (error) {
        setStatus("❌ An error occurred. Please try again later.");
    }
  };

  const toggleCommunication = () => {
    setCommunication(!communication);
  };

  return (
    <div className="contactContainer">
      <div className="contactHeader">
        <p className="sectionKicker">Get in Touch</p>
        <h1 className="sectionTitle mainColorText">Contact Big Circle Auctions</h1>
        <p className="contactSubtitle">
          Whether you’re a buyer, seller, or just curious — we’d love to hear from you.
        </p>
      </div>

      <form className="contactForm" onSubmit={handleSubmit}>
        <div className="hor-flex">
          <label>
            First Name
            <input
              type="text"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </label>
          

          <label>
            Last Name
            <input
              type="text"
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </label>
        </div>

        <label>Email</label>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Message</label>
        <textarea
          placeholder="Write your message here..."
          rows="5"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>

        <div className="checkboxRow">
          <input
            type="checkbox"
            checked={agreeTerms}
            onChange={(e) => setAgreeTerms(e.target.checked)}
          />
          <span>
            I agree to the{" "}
            <a href="/terms-conditions" target="_blank" rel="noreferrer">
              terms and conditions
            </a>
            {" "}&{" "}
            <a href="/privacy-policy" target="_blank" rel="noreferrer">
              privacy policy
            </a>
          </span>
        </div>

        <label className="termsCheckBox">
          <input type="checkbox" onChange={toggleCommunication} />
          I consent to receive text messages from Big Circle Auctions. Messages sent may include customer care, account notifications, 
          marketing and message frequency will be varied based on the customer's interaction and preferences.
          Message and data rates may apply. For assistance Text "HELP" or Contact us at contact@bigcircleauctions.com for support. Text STOP to opt out of future messages at anytime.
        </label>

        <button type="submit" className="contactButton">
          Send Message
        </button>

        {status && <p className="statusMessage">{status}</p>}
      </form>
    </div>
  );
}

export default ContactUs;
